// extracted by mini-css-extract-plugin
export var subtitle = "_9g-2";
export var title = "_9g-0";
export var titleNoWrap = "_9g-1";